<ion-header no-border>
  <ion-toolbar>

    <ion-buttons slot="start">
      <ion-button ion-button (click)="dismiss()" data-cy="editNotes-toolbar-dismiss">
        <ion-icon color="dark" class="modal-close" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title color="primary" data-cy="editNotes-form-title">
      Edit {{inputLabel}}
    </ion-title>

    <ion-buttons slot="end">
      <ion-button class="toolbarButton" color="primary" ion-button (click)="done()" data-cy="editNotes-toolbar-save">
        Save
      </ion-button>
    </ion-buttons>

  </ion-toolbar>
</ion-header>

<ion-content class="page-edit-notes padding">
<!-- 
  <h3 class="text-center color-dark">
    Edit {{inputLabel}}
  </h3> -->

  <div class="spacer-10"></div>

  <ion-label class="editFieldLabel">{{inputLabel}}</ion-label>

  <ion-item lines="none">
    <ion-textarea autocapitalize="sentences" lines="nons" #ionTextarea rows="3" [(ngModel)]="inputData"
      data-cy="editNotes-toolbar-input"></ion-textarea>
  </ion-item>

  <div [style.padding-bottom.px]="utils.keyboardHeight"></div>
</ion-content>